export default __webpack_public_path__ + "static/aboutUs-6603972f5fb2119f0f15ae11f01ae8fe.svg";